export default {
  open: "Open",
  cleared: "Cleared",
  closed: "Closed",
  favorites: "Favorites",
  assignedToYou: "Assigned To You",
};
